import { useCallback, useState } from 'react';

/**
 * Web <img> load-failure tracking. Many AWIN/Fnac events carry an image_url
 * that 404s (or is hotlink-blocked), so a null check alone isn't enough — the
 * URL is present but the image never renders. Callers swap in the
 * NoImagePlaceholder when `broken` is true.
 *
 * Covers both failure timings:
 * - `onError` for images that fail after hydration wires up the handler.
 * - `ref` for images that already failed in the static HTML before hydration
 *   (a broken image is `complete` with a zero `naturalWidth`), which the
 *   error event won't replay.
 */
export function useBrokenImage() {
  const [broken, setBroken] = useState(false);
  const ref = useCallback((img: HTMLImageElement | null) => {
    if (img && img.complete && img.naturalWidth === 0) setBroken(true);
  }, []);
  const onError = useCallback(() => setBroken(true), []);
  return { broken, ref, onError };
}
